import { ProductCategoryEnum } from 'legacy/shared-types';

export const tableColumnsNames = [
  'case',
  'purpose',
  'financingAmount',
  'referenceNumber',
  'applicant',
  'status',
  'createdAt',
] as (keyof BtlApplicationForListingDto)[];

export interface IApplicationsAnalystTableProps {
  searchInputValue: string;
}

export type BtlApplicationForListingDto = {
  id: string | number;
  title: string;
  purpose: string;
  financingAmount: number;
  referenceNumber?: string;
  applicant?: string;
  coApplicant?: string;
  status?: string;
  createdAt?: Date;
  productCategory?: ProductCategoryEnum;
};
